import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { getAnnotationAssignmentsTagOptions } from 'api/annotationAssignments';
import { TableEditingContextProvider } from 'components/atoms/EditableDataGrid/TableEditingContext';
import { RowSelectionContextProvider } from 'components/atoms/RowSelectionContext';
import AnnotationAssignmentTaggingDialog from '.';

interface Props {
  studyId?: string;
}

export const AnnotationAssignmentTaggingDialogWithContext: React.FC<Props> = ({ studyId }) => {
  const { data: tagOptions } = useQuery({
    queryKey: ['annotationAssignmentTagOptions'],
    queryFn: () => getAnnotationAssignmentsTagOptions(),
  });
  return (
    <RowSelectionContextProvider>
      <TableEditingContextProvider fieldsContext={{ tagOptions: tagOptions || [] }}>
        <AnnotationAssignmentTaggingDialog studyId={studyId} />
      </TableEditingContextProvider>
    </RowSelectionContextProvider>
  );
};
